/**
 * Der deutsche Katalog. Jeder Abschnitt ist gegen sein englisches Gegenstück typisiert: ein
 * fehlender oder überzähliger Schlüssel ist ein Übersetzungsfehler beim Kompilieren.
 * Terminologie: docs/Glossary.md.
 */
import { aar } from './de/aar';
import { academy } from './de/academy';
import { common } from './de/common';
import { dispatch } from './de/dispatch';
import { hud } from './de/hud';
import { manual } from './de/manual';
import { map } from './de/map';
import { menu } from './de/menu';
import { mp } from './de/mp';
import { news } from './de/news';
import { setup } from './de/setup';
import type { En } from './en';
import type { Translated } from './types';

export const de: Translated<En> = {
  ...common,
  ...menu,
  ...setup,
  ...mp,
  ...hud,
  ...dispatch,
  ...news,
  ...aar,
  ...manual,
  ...academy,
  ...map,
};
